const OTHER_SIZE_INDEX = 12;
/*
CASE
    WHEN T2.U_TSCFG_PROP2_VALUE = 'XS' THEN 1
    WHEN T2.U_TSCFG_PROP2_VALUE = 'SM' THEN 2
    WHEN T2.U_TSCFG_PROP2_VALUE = 'MD' THEN 3
    WHEN T2.U_TSCFG_PROP2_VALUE = 'LG' THEN 4
    WHEN T2.U_TSCFG_PROP2_VALUE = 'XL' THEN 5
    WHEN T2.U_TSCFG_PROP2_VALUE = 'XXL' THEN 6
    WHEN T2.U_TSCFG_PROP2_VALUE = '2XL' THEN 6
    WHEN T2.U_TSCFG_PROP2_VALUE = 'XXXL' THEN 7
    WHEN T2.U_TSCFG_PROP2_VALUE = '3XL' THEN 7
    WHEN T2.U_TSCFG_PROP2_VALUE = '4XL' THEN 8
    WHEN T2.U_TSCFG_PROP2_VALUE = 'XXXXL' THEN 8
    WHEN T2.U_TSCFG_PROP2_VALUE = '5XL' THEN 9
    WHEN T2.U_TSCFG_PROP2_VALUE = 'XXXXXL' THEN 9
    WHEN T2.U_TSCFG_PROP2_VALUE = '6XL' THEN 10
    WHEN T2.U_TSCFG_PROP2_VALUE = 'XXXXXXL' THEN 10
    WHEN T2.U_TSCFG_PROP2_VALUE = 'OSFM' THEN 11
    WHEN T2.U_TSCFG_PROP2_VALUE = 'OSMF' THEN 11
    ELSE 12 -- OTHER_SIZE_INDEX in the frontend
END AS size_index,

*/


// const sizeSorter = (a, b) => {
//   const aIndex = a.size_index ?? OTHER_SIZE_INDEX;
//   const bIndex = b.size_index ?? OTHER_SIZE_INDEX;

//   if (aIndex !== OTHER_SIZE_INDEX && bIndex === OTHER_SIZE_INDEX) return -1;
//   if (aIndex === OTHER_SIZE_INDEX && bIndex !== OTHER_SIZE_INDEX) return 1;

//   if (aIndex === OTHER_SIZE_INDEX && bIndex === OTHER_SIZE_INDEX) {
//     return a.size.localeCompare(b.size);
//   }

//   return aIndex - bIndex;
// };


const sizeSorter = (a, b) => {

    if (a.size_index !== OTHER_SIZE_INDEX && b.size_index === OTHER_SIZE_INDEX) {
        // an item with a common size always comes before an item of other type
        return -1;

    } else if (a.size_index === OTHER_SIZE_INDEX && b.size_index !== OTHER_SIZE_INDEX) {
        // an item with a uncommon size is always after an item with common size
        return 1;

    } else if (a.size_index === OTHER_SIZE_INDEX && b.size_index === OTHER_SIZE_INDEX) {
        // if both are an other type, fallback to alphabetical on size string
        if (a.size < b.size) {
            return -1;
        } else if (a.size > b.size) {
            return 1;
        }
        // * return 0 to keep them items in the order they appear
        return 0;
    }

    //  use the size_index from the query
    return a.size_index - b.size_index;
};

export default sizeSorter;
